import React, { useState, useEffect, useRef } from 'react'
import { Snackbar, CircularProgress } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import dayjs from 'dayjs'
import LogoP1 from '../../../../assets/images/logomain.png'
import useInvoiceBillStyles from './styles'
import '../../businessview-style.scss'
import axios from 'axios'
import InvoiceTable from './components/InvoiceTable'
import OutstandingPaymentsTable from './components/OutstandingPaymentsTable '
import FaultSummaryTable from './components/FaultSummaryTable'
import FaultEventsTable from './components/FaultEventsTable'
import EmailDialog from './components/EmailDialog'
// import useEmailSettings from '../../../../hooks/useEmailSettings'
import AutoReminderDialog from './components/AutoReminderDialog'
import ExportZohoDialog from './components/ExportZohoDialog'
import ActionButtons from './components/ActionButtons'
import emailTemplate from './utils/emailTemplate'
import { generatePDF } from './utils/pdfGenerator'
import PaymentStatusDialog from './components/PaymentStatusDialog'
import {
  getLastInvoiceNumber,
  updateInvoicestatus,
  updateMultipleFields,
  recordEmailStatus,
  updateInvoiceEmailStatus,
} from './utils/invoiceApi'
import processInvoiceData from './utils/processInvoiceData '
import moment from 'moment'
import { exportToZoho, getZohoInvoiceDetails } from './utils/ZohoApis'
import { expressURL } from '../../../../services/api'
import {
  fetchBillingRecordByPlantAndMonth,
  updateBillingRecordWithInvoice,
  syncBillingRecordFromInvoice,
} from '../../../../services/billingRecords.service'
import { fetchOrganizationData } from '../../../../services/organization.service'


// const SENDER_EMAIL = 'info@de.energy'
// // Default sender name used when no organization/zoho name is available
// const DEFAULT_SENDER_NAME = 'Distributed Energy'
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const InvoiceBill = ({
  DeemedlogData,
  invoiceReportList,
  state,
  invoiceDate,
  zohoState,
}) => {
  const classes = useInvoiceBillStyles()
  const [isLoading, setIsLoading] = useState(true)
  const [isDownloading, setIsDownloading] = useState(false)
  const [mainEnergy, setMainEnergy] = useState(0)

  const [omAmounts, setOmAmounts] = useState(0)
  const [accountableFailure, setAccountableFailure] = useState(0)
  const [faultEvents, setFaultEvents] = useState({
    GridFailure: 0,
    InverterFailure: 0,
    Manuallyinverterbreakerturnedoff: 0,
    VoltageFluctuations: 0,
    RelayFailureMCCBFailure: 0,
    AnyOtherFault: 0,
    CableTerminationIssue: 0,
  })
  // Initialize with last day of the selected billing month (invoiceDate prop)
  const getDefaultInvoiceDate = () => {
    if (!invoiceDate) return new Date().toISOString().split('T')[0]
    // Parse the billing month and set to last day of that month
    const billingDate = dayjs(invoiceDate)
    return billingDate.endOf('month').format('YYYY-MM-DD')
  }

  const [firstDate, setFirstDate] = useState(getDefaultInvoiceDate())
  const [dateloed, setDateLoed] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [faultSummary, setFaultSummary] = useState([])
  const [outstandingPayments, setOutstandingPayments] = useState([])
  const [editingPaymentId, setEditingPaymentId] = useState(null)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [emailType, setEmailType] = useState('')
  const [autoReminderDialogOpen, setAutoReminderDialogOpen] = useState(false)
  const [paymentStatusDialogOpen, setPaymentStatusDialogOpen] = useState(false)
  const [pendingPaymentStatus, setPendingPaymentStatus] = useState(null)
  const [exportZohoDialogOpen, setExportZohoDialogOpen] = useState(false)
  const [pendingAutoReminderStatus, setPendingAutoReminderStatus] =
    useState(false)
  const [emailDialogData, setEmailDialogData] = useState({
    toEmails: [],
    ccEmails: [],
    isLoading: false,
    error: null,
  })

  const handleEmailButtonClick = async (type) => {
    setEmailType(type)
    setEmailDialogData((prev) => ({ ...prev, isLoading: true, error: null }))

    try {
      if (type === 'team') {
        // Fetch team emails directly from the API
        const response = await fetch(`${expressURL}/api/email-settings/invoice`);
        if (!response.ok) {
          throw new Error('Failed to fetch team email settings');
        }
        const data = await response.json();
        console.log("team invoice", data);

        // Extract and validate team emails
        const teamToEmails = data.to?.map(recipient => recipient.email).filter(email => email && typeof email === 'string') || [];
        const teamCcEmails = data.cc?.map(recipient => recipient.email).filter(email => email && typeof email === 'string') || [];

        console.log('Processed team TO emails:', teamToEmails);
        console.log('Processed team CC emails:', teamCcEmails);

        if (teamToEmails.length === 0 && teamCcEmails.length === 0) {
          throw new Error('No valid team email recipients found');
        }

        setEmailDialogData((prev) => ({
          ...prev,
          toEmails: teamToEmails,
          ccEmails: teamCcEmails,
          isLoading: false,
        }));
      } else {
        try {
          // Fetch recipients from backend via invoiceId
          const invoice_id = invoiceDetails?.[0]?._id
          const token = localStorage.getItem('accessToken')
          if (!invoice_id) throw new Error('Invoice not found. Please create or select an invoice.')

          const resp = await fetch(`${expressURL}/invoice-reminder/recipients?invoiceId=${invoice_id}&recipientType=customer`, {
            headers: {
              'Accept': 'application/json',
              ...(token && { 'Authorization': `Bearer ${token}` })
            }
          })
          if (!resp.ok) {
            const txt = await resp.text()
            throw new Error(`Failed to load recipients: ${resp.status} ${txt}`)
          }
          const data = await resp.json()
          const toEmails = Array.isArray(data.to) ? data.to : []
          const ccEmails = Array.isArray(data.cc) ? data.cc : []

          setEmailDialogData((prev) => ({
            ...prev,
            toEmails,
            ccEmails,
            isLoading: false,
          }))
        } catch (err) {
          console.error('Error fetching customer recipients:', err)
          setEmailDialogData((prev) => ({
            ...prev,
            toEmails: [],
            ccEmails: [],
            isLoading: false,
            error: err.message,
          }))
        }
      }
    } catch (error) {
      console.error('Error in email handling:', error)
      setEmailDialogData((prev) => ({
        ...prev,
        error: error.message,
        isLoading: false,
      }))
    }

    setConfirmDialogOpen(true)
  }
  const [printMode, setPrintMode] = useState(false)
  const [invoiceDetails, setInvoiceDetails] = useState(null)
  const [zohoConnected, setZohoConnected] = useState(false)
  const [zohoinvoicenumber, setzohoinvoicenumber] = useState('')
  const [processingButton, setProcessingButton] = useState(null) // null, 'emailTeam', 'emailCustomer', 'saveDownload', 'exportZoho'
  const [dueDate, setDueDate] = useState(null)
  const [autoGenerate, setAutoGenerate] = useState(false)
  const [automated, setAutomated] = useState(false)
  const [createdAt, setCreatedAt] = useState(null)
  const [updatedAt, setUpdatedAt] = useState(null)

  const [emailStatus, setEmailStatus] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  // Debug: log emailStatus changes to help diagnose snackbar visibility
  useEffect(() => {
    console.log('emailStatus changed:', emailStatus)
  }, [emailStatus])

  const [saveStatus, setSaveStatus] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  // Add these states in the InvoiceBill component
  const [isSaving, setIsSaving] = useState(false)
  const [isUpdatingFromDB, setIsUpdatingFromDB] = useState(false) // New flag to prevent useEffect interference
  const [paymentStatus, setPaymentStatus] = useState('UNPAID') // Working status (dropdown)
  const [dbPaymentStatus, setDbPaymentStatus] = useState('UNPAID') // Saved DB status (display only)
  const [billingRecord, setBillingRecord] = useState(null)
  const [billingRecordError, setBillingRecordError] = useState(null)
  const [invoiceModal, setInvoiceModal] = useState({
    open: false,
    type: '', // 'success', 'error', 'info'
    title: '',
    message: '',
  })

  // Organization details state
  const [organizationData, setOrganizationData] = useState({
    organizationName: '',
    address: '',
    gstNumber: '',
    loading: false,
    error: null
  })

  // Plant size from billing record
  const [plantSize, setPlantSize] = useState(null)
  const chosenDate = dayjs(invoiceDate)

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const today = new Date(invoiceDate)
  const CurrentMonth = today.getMonth()

  const dateObject = dayjs(invoiceDate).format('YYYY-MM-DD') // Format as string for API
  const invoiceYear = dayjs(invoiceDate).year()
  const invoiceMonth = dayjs(invoiceDate).format('MMMM')

  const fetchZohoInvoicesByPlantId = async (passedOrgId = null) => {
    try {
      // console.log('🔢 fetchZohoInvoicesByPlantId called')
      // console.log('📋 Current invoiceDetails:', invoiceDetails)
      // console.log('🏢 Organization ID from state:', state?.data?.organizationId)
      // console.log('🏢 Billing record org ID:', billingRecord?.organizationId)
      // console.log('🏢 Passed org ID:', passedOrgId)

      // Only use getLastInvoiceNumber if invoice is not stored
      if (!invoiceDetails || invoiceDetails.length === 0) {
        // Use passed organizationId first, then billing record, then state
        const orgId = passedOrgId || billingRecord?.organizationId || state?.data?.organizationId

        if (!orgId) {
          console.error('❌ No organizationId available for invoice number generation')
          setzohoinvoicenumber('INV-MISSING-ORG-ID')
          return
        }

        console.log(`🔢 Calling getLastInvoiceNumber with orgId: ${orgId}`)
        const response = await getLastInvoiceNumber(orgId, dateObject)

        const finalInvoiceNumber = response?.invoiceNumber
        console.log('✅ Generated invoice number:', finalInvoiceNumber)

        if (finalInvoiceNumber) {
          setzohoinvoicenumber(finalInvoiceNumber)
        } else {
          console.error('❌ Invoice number generation failed')
          // Generate fallback invoice number
          const fallbackNumber = `INV-${dayjs(invoiceDate).format('YYYYMM')}-${String(Math.floor(Math.random() * 1000)).padStart(3, '0')}`
          console.warn(`⚠️ Using fallback invoice number: ${fallbackNumber}`)
          setzohoinvoicenumber(fallbackNumber)
        }
      } else {
        console.log('ℹ️ Invoice already exists, using stored invoice number')
      }
      // If invoice is stored, don't override the invoice number
      // The stored invoice number is already set by fetchInvoicesByPlantId
    } catch (error) {
      console.error('❌ Error in fetchZohoInvoicesByPlantId:', error.message)
      // Generate fallback invoice number on error
      const fallbackNumber = `INV-${dayjs(invoiceDate).format('YYYYMM')}-ERR`
      console.warn(`⚠️ Using error fallback invoice number: ${fallbackNumber}`)
      setzohoinvoicenumber(fallbackNumber)
    }
  }

  // Fetch billing record for the selected month using V4 API
  // This function ONLY fetches and returns data - does NOT set form state
  const fetchBillingRecordForMonth = async (plantId, invoiceDate) => {
    try {
      setBillingRecordError(null)

      // Format record date as YYYY-MM for V4 API
      const recordDateYYYYMM = dayjs(invoiceDate).format('YYYY-MM')
      const apiUrl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING

      console.log(`🔍 Fetching billing record: ${apiUrl}billing?plantId=${plantId}&recordDate=${recordDateYYYYMM}`)

      // Fetch from V4 billing API (monitoring-microservice on port 3003)
      const authToken = localStorage.getItem('accessToken')
      const response = await fetch(
        `${apiUrl}billing?plantId=${plantId}&recordDate=${recordDateYYYYMM}`,
        {
          headers: {
            Accept: 'application/json',
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
          },
        }
      )

      if (!response.ok) {
        const errorText = await response.text()
        console.error('❌ Billing API error response:', errorText)
        throw new Error(`Failed to fetch billing record from V4 API: ${response.status} ${response.statusText}`)
      }

      const result = await response.json()
      console.log('📦 Billing API response:', result)

      if (result.success && result.data && result.data.length > 0) {
        const billingData = result.data[0] // Get first record (should only be one per plant per month)
        setBillingRecord(billingData)

        // console.log('✅ Billing record found:', billingData)

        // Fetch organization data if organizationId exists
        if (billingData.organizationId) {
          // console.log('📋 Fetching organization data for ID:', billingData.organizationId)
          await fetchOrganizationDetails(billingData.organizationId)
        } else {
          console.warn('⚠️ No organizationId in billing record')
        }

        return billingData
      } else {
        setBillingRecord(null)
        console.warn("⚠️ No billing record found for this month in V4 API")
        return null
      }
    } catch (error) {
      console.error('❌ Error fetching billing record from V4 API:', error)
      setBillingRecordError(error.message)
      setBillingRecord(null)
      return null
    }
  }

  // Fetch organization details using organization service
  const fetchOrganizationDetails = async (organizationId) => {
    setOrganizationData((prev) => ({ ...prev, loading: true, error: null }))

    try {
      // console.log('🏢 Fetching organization details for ID:', organizationId)
      const result = await fetchOrganizationData(organizationId)

      if (result.success && result.data) {
        setOrganizationData({
          organizationName: result.data.organizationName || billingRecord?.organizationName || '',
          address: result.data.address || '',
          gstNumber: result.data.gstNumber || '',
          loading: false,
          error: null
        })
        // console.log(`✅ Organization data loaded from ${result.source}:`, result.data)
      } else {
        // Use billing record organization name as fallback
        console.warn('⚠️ Could not fetch organization data, using billing record fallback')
        setOrganizationData({
          organizationName: billingRecord?.organizationName || `Organization ${organizationId}`,
          address: '',
          gstNumber: '',
          loading: false,
          error: result.error || 'Organization details unavailable'
        })
      }
    } catch (error) {
      console.error('❌ Error fetching organization details:', error)
      // Use billing record organization name as ultimate fallback
      setOrganizationData({
        organizationName: billingRecord?.organizationName || `Organization ${organizationId}`,
        address: '',
        gstNumber: '',
        loading: false,
        error: error.message || 'Failed to load organization details'
      })
    }
  }

  // Sync payment status to billing record
  const syncPaymentStatusToBillingRecord = async (newStatus) => {
    if (!billingRecord) {
      console.warn('No billing record to update')
      return
    }

    try {
      const recordId = billingRecord.id || billingRecord._id
      if (!recordId) {
        console.error('❌ Billing record ID is missing. Cannot update payment status.')
        return
      }
      await updateBillingRecordWithInvoice(recordId, {
        paymentStatus: newStatus,
      })
      console.log(`✅ Billing record payment status updated to: ${newStatus}`)
    } catch (error) {
      console.error('Error syncing payment status to billing record:', error)
    }
  }

  const handleAutoReminderClick = (newStatus) => {
    // Check if invoice exists before allowing auto reminder changes
    if (!invoiceDetails || invoiceDetails.length === 0) {
      setEmailStatus({
        open: true,
        message: 'Please create invoice first',
        severity: 'warning',
      })
      return
    }

    setPendingAutoReminderStatus(newStatus)
    setAutoReminderDialogOpen(true)
  }

  const handleConfirmAutoReminder = () => {
    // Close dialog first to prevent FocusTrap issues
    setAutoReminderDialogOpen(false)
    // Delay state update to ensure dialog is fully closed
    setTimeout(() => {
      updateAutomationStatus(pendingAutoReminderStatus)
    }, 100)
  }

  const updateAutomationStatus = async (automationStatus) => {
    try {
      const invoice_id = invoiceDetails?.[0]?._id
      if (!invoice_id) {
        console.error('No invoice ID found. This is for changing the status, or setting reminder')
        setEmailStatus({
          open: true,
          message: 'No invoice ID found. Please create an invoice first.',
          severity: 'error',
        })
        return
      }

      const updatedFields = {
        autoGenerate: Boolean(automationStatus),
        automated: Boolean(automationStatus),
        updatedAt: new Date().toISOString(),
      }

      console.log('Sending automation update:', updatedFields)

      // Get auth token for V4 API
      const authToken = localStorage.getItem('accessToken')
      const url = `${expressURL}/invoices/${invoice_id}`
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify(updatedFields),
      })

      if (response.ok) {
        const responseData = await response.json()
        console.log('Automation status updated successfully:', responseData)

        // Set flag to prevent useEffect interference
        setIsUpdatingFromDB(true)

        // Update local state
        setAutoGenerate(Boolean(automationStatus))
        setAutomated(Boolean(automationStatus))
        setUpdatedAt(new Date().toISOString())

        // Refresh invoice data from database to ensure consistency
        await fetchInvoicesByPlantId(true, false)

        // Reset flag after a brief delay
        setTimeout(() => {
          setIsUpdatingFromDB(false)
        }, 100)
      } else {
        const errorData = await response.json()
        console.error('Error updating automation status:', errorData)
      }
    } catch (error) {
      console.error('Update automation status error:', error)
    }
  }

  const handlePaymentStatusChange = (newStatus) => {
    // Check if invoice exists before allowing changes
    if (!invoiceDetails || invoiceDetails.length === 0) {
      setEmailStatus({
        open: true,
        message: 'Please create invoice first',
        severity: 'warning',
      })
      return
    }

    setPendingPaymentStatus(newStatus)
    setPaymentStatusDialogOpen(true)
  }

  const handleConfirmPaymentStatusChange = async () => {
    setPaymentStatusDialogOpen(false)
    const newStatus = pendingPaymentStatus

    try {
      // Update local state immediately for UI responsiveness
      setPaymentStatus(newStatus)

      const invoice_id = invoiceDetails?.[0]?._id
      if (!invoice_id) {
        console.error('No invoice ID found for payment status update')
        setEmailStatus({
          open: true,
          message: 'No invoice ID found. Please create an invoice first.',
          severity: 'error',
        })
        return
      }

      // Call API to persist payment status change 
      const { setPaymentStatus: updatePaymentStatusAPI } = await import('./utils/invoiceApi')
      const result = await updatePaymentStatusAPI({ invoice_id, paymentStatus: newStatus })

      if (result.success) {
        // Update the DB status to reflect what's saved in the backend
        setDbPaymentStatus(newStatus)
        console.log(`✅ Payment status updated to: ${newStatus}`)

        // Sync payment status to billing record
        try {
          await syncBillingRecordFromInvoice(state?.data?.id, invoiceDate, {
            paymentStatus: newStatus,
          })
          console.log(`✅ Billing record payment status synced to: ${newStatus}`)
        } catch (syncError) {
          console.error('Error syncing payment status to billing record:', syncError)
        }

        setEmailStatus({
          open: true,
          message: `Payment status updated to ${newStatus}`,
          severity: 'success',
        })

        // Note: Don't call fetchInvoicesByPlantId here to avoid infinite loop
        // The useEffect watching invoiceDetails will handle data refresh if needed
      } else {
        // Revert local state if API call failed
        setPaymentStatus(dbPaymentStatus)
        console.error('Failed to update payment status:', result.error)
        setEmailStatus({
          open: true,
          message: `Failed to update payment status: ${result.error}`,
          severity: 'error',
        })
      }
    } catch (error) {
      console.error('Payment status update error:', error)
      // Revert local state on error
      setPaymentStatus(dbPaymentStatus)
      setEmailStatus({
        open: true,
        message: 'Error updating payment status. Please try again.',
        severity: 'error',
      })
    }
  }

  const fetchInvoicesByPlantId = async (
    preserveCurrentDate = false,
    preventStateUpdate = false
  ) => {
    console.log('Invoice Fetching invoices for plantId:', state?.data?.id)
    console.log('Invoice Date:', invoiceDate)
    console.log('data:', state?.data)

    // Parse invoiceDate using dayjs to handle both Date objects and strings
    const parsedDate = dayjs(invoiceDate)
    const year = parsedDate.format('YYYY')
    const monthIndex = parsedDate.month() // 0-indexed
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December']
    const month = monthNames[monthIndex]

    // V4 endpoint: /invoices?plantId=xxx&month=xxx&year=xxx
    const url = `${expressURL}/invoices?plantId=${state.data.id}&month=${month}&year=${year}`

    console.log('🔍 Fetching invoice with V4 URL:', url)

    try {
      // Get auth token from localStorage
      const authToken = localStorage.getItem('accessToken')

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch invoices. Status: ${response.status}`)
      }

      const invoiceResponse = await response.json()
      console.log('📦 V4 Invoice API response:', invoiceResponse)

      // V4 returns { invoices: [...], total: number }
      // Map V4 response format to expected frontend format
      const v4Invoices = invoiceResponse.invoices || []
      const mappedInvoices = v4Invoices.map(inv => {
        // First, store raw data reference
        const rawInvoice = inv

        return {
          // CRITICAL: _id is required for update operations - use invoiceId from V4
          _id: inv.invoiceId,
          id: inv.invoiceId,

          // Basic fields
          invoiceNumber: inv.invoiceNumber,
          type: inv.type,
          plantId: inv.associations?.plant?.plantId,
          plantName: inv.associations?.plant?.plantName,

          // Status fields - V4 uses 'status' field for invoice status and 'paymentStatus' for payment
          status: inv.status,
          paymentStatus: inv.paymentStatus || 'UNPAID',

          // Financial fields
          invoiceValue: inv.financial?.totalAmount || inv.financial?.amount || 0,
          amount: inv.financial?.amount || 0,
          totalAmount: inv.financial?.totalAmount || 0,

          // Energy/Generation fields (from V4 energyData if present)
          deemedEnergy: inv.energyData?.deemedGeneration || rawInvoice.deemedEnergy || 0,
          deemedGeneration: inv.energyData?.deemedGeneration || rawInvoice.deemedGeneration || 0,
          // Tariff fields - check multiple possible locations
          deemedTariff: inv.tariff?.baseRate || rawInvoice.deemedTariff || 0,
          mainTariff: inv.tariff?.baseRate || rawInvoice.mainTariff || 0,
          energyValue: inv.energyData?.actualGeneration || rawInvoice.energyValue || 0,

          // Date fields
          invoiceDate: inv.dates?.invoiceDate,
          dueDate: inv.dates?.dueDate,
          sentDate: inv.dates?.sentDate,
          createdAt: inv.dates?.createdAt,
          updatedAt: inv.dates?.updatedAt,

          // Automation fields - directly from invoice
          automated: inv.automated || false,
          autoGenerate: inv.automated || false,
          emailSent: inv.emailSent || false,

          // Zoho integration - use the direct fields from API response
          sentToZoho: inv.sentToZoho || false,
          zohoInvoiceId: inv.zohoUpdates?.zohoInvoiceId,
          zohoinvoicenumber: inv.zohoinvoicenumber || inv.invoiceNumber,

          // Organization
          organizationId: inv.organizationId,
          organizationName: inv.associations?.organization?.organizationName,

          // Keep raw V4 data for reference (used for accessing unmapped fields)
          _v4Raw: rawInvoice
        }
      })

      const invoiceData = { data: mappedInvoices }
      console.log('📄 Mapped invoice data array:', invoiceData.data)
      console.log('📊 Number of invoices found:', invoiceData.data?.length || 0)

      // Only update invoice details if not preventing state updates
      if (!preventStateUpdate) {
        // Update invoice details state
        setInvoiceDetails(invoiceData.data)

        // Update the invoice number from the stored data
        const storedInvoiceNumber = invoiceData.data?.[0]?.invoiceNumber
        if (storedInvoiceNumber) {
          setzohoinvoicenumber(storedInvoiceNumber)
        }

        // Update paymentStatus from the stored data
        const storedPaymentStatus = invoiceData.data?.[0]?.paymentStatus
        if (storedPaymentStatus !== undefined) {
          // Normalize to uppercase for consistency
          const normalizedStatus = storedPaymentStatus.toUpperCase()
          setPaymentStatus(normalizedStatus) // Set working status
          setDbPaymentStatus(normalizedStatus) // Set DB status for display
        }

        // Update Zoho connection status based on sentToZoho field
        const storedSentToZoho = invoiceData.data?.[0]?.sentToZoho
        setZohoConnected(storedSentToZoho || false)
        const storedAutoGenerate = invoiceData.data?.[0]?.autoGenerate
        const storedAutomated = invoiceData.data?.[0]?.automated
        const storedCreatedAt = invoiceData.data?.[0]?.createdAt
        const storedUpdatedAt = invoiceData.data?.[0]?.updatedAt

        // If either field exists, use it to set both states (for backward compatibility)
        const automationValue =
          storedAutoGenerate !== undefined
            ? Boolean(storedAutoGenerate)
            : storedAutomated !== undefined
              ? Boolean(storedAutomated)
              : false

        console.log(
          'Fetched automation values - autoGenerate:',
          storedAutoGenerate,
          'automated:',
          storedAutomated,
          'Final value:',
          automationValue
        )

        setAutoGenerate(automationValue)
        setAutomated(automationValue)
        if (storedCreatedAt) {
          setCreatedAt(storedCreatedAt)
        }
        if (storedUpdatedAt) {
          setUpdatedAt(storedUpdatedAt)
        }

        // Only update the date if we're not preserving the current date AND there's no current date set
        if (
          !preserveCurrentDate &&
          (!firstDate || firstDate === new Date().toISOString().split('T')[0])
        ) {
          // Use invoiceDate from DB instead of sentDate
          const inv = invoiceData.data?.[0]?.invoiceDate
          if (inv) {
            setFirstDate(dayjs(inv).format('YYYY-MM-DD'))
          }
        }

        // Populate dueDate from DB if available
        const storedDueDate = invoiceData.data?.[0]?.dueDate
        if (storedDueDate) {
          setDueDate(dayjs(storedDueDate).format('YYYY-MM-DD'))
        } else {
          // Compute default due date using paymentTermsDays
          const terms = Number(state?.data?.paymentTermsDays) || 7
          const baseDate = invoiceData.data?.[0]?.invoiceDate || invoiceDate
          setDueDate(dayjs(baseDate).add(terms, 'day').format('YYYY-MM-DD'))
        }
      }

      return invoiceData
    } catch (error) {
      console.error('Error fetching invoice:', error.message)
      throw error
    }
  }

  // Fetch invoice data when the component is mounted
  useEffect(() => {
    const initializeData = async () => {

      console.log('🔄 Initializing invoice form...')

      // Step 1: Fetch billing record from V4 (REQUIRED - contains generation data)
      let billingRecordData = null
      if (state?.data?.id) {
        console.log('📊 Fetching V4 billing record for plant:', state.data.id)
        billingRecordData = await fetchBillingRecordForMonth(state.data.id, invoiceDate)
      }

      if (!billingRecordData) {
        console.error('❌ No billing record found - cannot proceed')
        setInvoiceDetails([])
        return
      }

      console.log('✅ Billing record found:', billingRecordData)

      // Step 2: Check if invoice exists in V4 invoices collection
      console.log('🔍 Checking V4 invoices collection...')
      let invoiceData = null
      let hasInvoiceInV4 = false
      try {
        invoiceData = await fetchInvoicesByPlantId()
        hasInvoiceInV4 = invoiceData?.data && invoiceData.data.length > 0
      } catch (invoiceError) {
        console.warn('⚠️ Error fetching invoices (continuing with billing record data):', invoiceError.message)
        // Continue with billing record data - invoice fetch failure shouldn't stop form population
      }

      if (hasInvoiceInV4) {
        console.log('📄 INVOICE EXISTS in V4 collection - Show UPDATE button')
        // Invoice created - invoiceDetails already set by fetchInvoicesByPlantId
      } else {
        console.log('NO INVOICE in V4 collection')
        // No invoice yet - clear invoiceDetails
        setInvoiceDetails([])
      }

      // Step 3: Fetch organization data if organizationId exists
      if (billingRecordData.organizationId) {
        console.log('Fetching organization data for ID:', billingRecordData.organizationId)
        await fetchOrganizationDetails(billingRecordData.organizationId)
      } else {
        console.warn('No organizationId in billing record')
      }

      // Step 4: Set plant size from billing record
      if (billingRecordData.plantSize) {
        setPlantSize(billingRecordData.plantSize)
        console.log('Plant size from billing record:', billingRecordData.plantSize)
      }

      // Step 5: Pre-fill form fields from billing record (always from V4)
      console.log('📝 Pre-filling form from billing record...')

      if (billingRecordData.actualGeneration !== undefined) {
        const formattedGeneration = billingRecordData.actualGeneration === 0
          ? '0'
          : billingRecordData.actualGeneration % 1 === 0
            ? billingRecordData.actualGeneration.toString()
            : parseFloat(billingRecordData.actualGeneration).toFixed(2)
        setEnergyValu(formattedGeneration)
        setMainEnergy(formattedGeneration)
      }

      if (billingRecordData.deemedGeneration !== undefined) {
        setDeemedEnergy(billingRecordData.deemedGeneration)
      }

      if (billingRecordData.tariff !== undefined) {
        setMainTariff(billingRecordData.tariff)
        setDeemedTariff(billingRecordData.tariff)
        console.log('💰 Tariff set from billing record:', billingRecordData.tariff)
      }

      // Step 6: Generate invoice number if no invoice exists
      if (!hasInvoiceInV4) {
        console.log('🔢 Generating next invoice number...')
        // Pass organizationId directly to avoid timing issue with React state
        await fetchZohoInvoicesByPlantId(billingRecordData.organizationId)
      }

      // Step 7: Set payment status (always UNPAID for new invoices)
      if (!hasInvoiceInV4) {
        setPaymentStatus('UNPAID')
        setDbPaymentStatus('UNPAID')
        console.log('💳 New invoice - Default status: UNPAID')
      }

      // Step 8: Set default invoice date (last day of billing month)
      if (!hasInvoiceInV4) {
        setFirstDate(dayjs(invoiceDate).endOf('month').format('YYYY-MM-DD'))
      }
    }
    initializeData()
  }, [invoiceDate]) // ✅ Re-run when invoice date changes

  // Reset firstDate when billing month changes (only if no invoice exists yet)
  useEffect(() => {
    if (!invoiceDetails || invoiceDetails.length === 0) {
      const newDefaultDate = getDefaultInvoiceDate()
      console.log('📅 Billing month changed, resetting invoice date to:', newDefaultDate)
      setFirstDate(newDefaultDate)
    }
  }, [invoiceDate])

  // Don't call fetchZohoInvoicesByPlantId on invoiceDetails changes
  // since fetchInvoicesByPlantId already handles setting the stored invoice number

  const deemedTariffValue =
    invoiceDetails?.find((item) => item.deemedTariff)?.deemedTariff ?? 0
  const deemedEnergyValue =
    invoiceDetails?.find((item) => item.deemedEnergy)?.deemedEnergy ?? 0
  const mainTariffValue =
    invoiceDetails?.find((item) => item.mainTariff)?.mainTariff ?? 0

  console.log(
    'deemedTariffValue',
    deemedTariffValue,
    deemedEnergyValue,
    mainTariffValue
  )

  const [deemedEnergy, setDeemedEnergy] = useState(deemedEnergyValue)
  const [mainTariff, setMainTariff] = useState(mainTariffValue)
  const [deemedTariff, setDeemedTariff] = useState(deemedTariffValue)

  // Fix 1: Update the useEffect that handles invoiceDetails changes
  useEffect(() => {
    if (
      invoiceDetails &&
      invoiceDetails.length > 0 &&
      !isSaving &&
      !isUpdatingFromDB
    ) {
      const storedDeemedEnergy = invoiceDetails.find(
        (item) => item.deemedEnergy !== undefined
      )?.deemedEnergy
      const storedDeemedTariff = invoiceDetails.find(
        (item) => item.deemedTariff !== undefined
      )?.deemedTariff
      const storedMainTariff = invoiceDetails.find(
        (item) => item.mainTariff !== undefined
      )?.mainTariff
      const storedEnergyValue = invoiceDetails.find(
        (item) => item.energyValue !== undefined
      )?.energyValue
      const storedPaymentStatus = invoiceDetails.find(
        (item) => item.paymentStatus !== undefined
      )?.paymentStatus
      const storedInvoiceDate = invoiceDetails.find(
        (item) => item.invoiceDate !== undefined
      )?.invoiceDate
      const storedDueDate = invoiceDetails.find(
        (item) => item.dueDate !== undefined
      )?.dueDate
      const storedAutoGenerate = invoiceDetails.find(
        (item) => item.autoGenerate !== undefined
      )?.autoGenerate
      const storedAutomated = invoiceDetails.find(
        (item) => item.automated !== undefined
      )?.automated
      const storedCreatedAt = invoiceDetails.find(
        (item) => item.createdAt !== undefined
      )?.createdAt
      const storedUpdatedAt = invoiceDetails.find(
        (item) => item.updatedAt !== undefined
      )?.updatedAt

      console.log(
        'useEffect: Loading from DB - autoGenerate:',
        storedAutoGenerate,
        'automated:',
        storedAutomated,
        'Types:',
        typeof storedAutoGenerate,
        typeof storedAutomated
      )

      // Update values if they exist in the database (including zero values)
      if (storedDeemedEnergy !== undefined) {
        setDeemedEnergy(storedDeemedEnergy)
      }
      if (storedDeemedTariff !== undefined) {
        setDeemedTariff(storedDeemedTariff)
      }
      if (storedMainTariff !== undefined) {
        setMainTariff(storedMainTariff)
      }
      if (storedEnergyValue !== undefined) {
        setEnergyValu(storedEnergyValue)
        setMainEnergy(storedEnergyValue)
      }
      if (storedPaymentStatus !== undefined) {
        setPaymentStatus(storedPaymentStatus) // Set working status
        setDbPaymentStatus(storedPaymentStatus) // Set DB status for display
      }
      if (storedInvoiceDate) {
        setFirstDate(storedInvoiceDate)
      }
      if (storedDueDate) {
        setDueDate(storedDueDate)
      } else {
        const terms = Number(state?.data?.paymentTermsDays) || 7
        setDueDate(
          dayjs(firstDate || invoiceDate)
            .add(terms, 'day')
            .format('YYYY-MM-DD')
        )
      }

      // Handle automation fields - use either field if present (backward compatibility)
      const automationValue =
        storedAutoGenerate !== undefined
          ? Boolean(storedAutoGenerate)
          : storedAutomated !== undefined
            ? Boolean(storedAutomated)
            : false

      console.log('useEffect: Setting automation to:', automationValue)
      setAutoGenerate(automationValue)
      setAutomated(automationValue)
      if (storedCreatedAt) {
        setCreatedAt(storedCreatedAt)
      }
      if (storedUpdatedAt) {
        setUpdatedAt(storedUpdatedAt)
      }
    }
  }, [invoiceDetails, isSaving, isUpdatingFromDB])

  const targetRef = useRef()

  const calculateTotals = () => {
    const effectiveEnergy =
      energyValu !== null && energyValu !== undefined
        ? parseFloat(energyValu)
        : parseFloat(mainEnergy || 0)

    const mainAmount = effectiveEnergy * parseFloat(mainTariff || 0)

    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)

    // Calculate totaltarif based on proposal type
    const totaltarif =
      parseFloat(mainTariff || 0) + parseFloat(deemedTariff || 0)
    const totalAmount = mainAmount + deemedAmount
    const totalBillableUnits = effectiveEnergy + parseFloat(deemedEnergy || 0)
    const totalFailure = Object.values(faultEvents).reduce(
      (sum, value) => sum + parseFloat(value || 0),
      0
    )

    // Calculate rounding for invoiceValue
    const subTotal =
      state?.data?.proposalType?.type === 'EMI' ? totaltarif : totalAmount
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const paymentTotals = calculatePaymentTotals()

    return {
      mainAmount,
      deemedAmount,
      totalAmount,
      totaltarif,
      totalBillableUnits,
      totalFailure,
      subTotal,
      roundedTotal,
      roundingOff,
      outstandingTotal: paymentTotals.outstandingTotal,
      pendingTotal: paymentTotals.pendingTotal,
    }
  }

  const calculatePaymentTotals = () => {
    return outstandingPayments.reduce(
      (acc, payment) => ({
        outstandingTotal:
          acc.outstandingTotal + Number(payment.invoiceAmount || 0),
        pendingTotal: acc.pendingTotal + Number(payment.pendingAmount || 0),
      }),
      { outstandingTotal: 0, pendingTotal: 0 }
    )
  }

  const energyValue =
    invoiceDetails?.find((item) => item.energyValue)?.energyValue ?? null
  const invoiceNumber =
    invoiceDetails?.find((item) => item.invoiceNumber)?.invoiceNumber ?? null
  const deemedGeneration =
    invoiceDetails?.find((item) => item.deemedGeneration)?.deemedGeneration ??
    null

  const invoice_id = invoiceDetails?.find((item) => item._id)?._id
  const [energyValu, setEnergyValu] = useState(energyValue)
  const [deemedGener, setDeemedGener] = useState(deemedGeneration)

  useEffect(() => {
    if (energyValue !== null) {
      const num = parseFloat(energyValue)
      // If it's zero or no value, set to '0', otherwise format properly
      if (num === 0) {
        setEnergyValu('0')
      } else {
        setEnergyValu(num % 1 === 0 ? num.toString() : num.toFixed(2))
      }
    }
  }, [energyValue]) // Runs whenever energyValue changes

  useEffect(() => {
    if (deemedGeneration !== null) {
      const num = parseFloat(deemedGeneration)
      // If it's zero or no value, set to '0', otherwise format properly
      if (num === 0) {
        setDeemedGener('0')
      } else {
        setDeemedGener(num % 1 === 0 ? num.toString() : num.toFixed(2))
      }
    }
  }, [deemedGeneration])

  // Create a function to generate PDF with specific values (prevents state interference)
  const generatePDFWithValues = async (specificValues) => {
    // Temporarily store current state values
    const currentValues = {
      energyValu,
      deemedEnergy,
      deemedTariff,
      mainTariff,
      firstDate,
      deemedGener, // ADD THIS LINE - Include deemedGener in preserved values
    }

    try {
      // Temporarily set the specific values for PDF generation
      if (specificValues) {
        setEnergyValu(specificValues.energyValu)
        setDeemedEnergy(specificValues.deemedEnergy)
        setDeemedTariff(specificValues.deemedTariff)
        setMainTariff(specificValues.mainTariff)
        setFirstDate(specificValues.firstDate)
        setDeemedGener(specificValues.deemedGener) // ADD THIS LINE - Set deemedGener

        // Wait a bit to ensure state is updated
        await new Promise((resolve) => setTimeout(resolve, 100))
      }

      const pdfs = await generatePDF(false, state)

      // Download each PDF with a specific filename
      pdfs.forEach((pdf, index) => {
        const filename = index === 0 ? 'Invoice.pdf' : `O&MInvoice.pdf`
        pdf.save(filename)
      })

      setPrintMode(true)

      return pdfs
    } finally {
      // Always restore the original values
      if (specificValues) {
        setTimeout(() => {
          setEnergyValu(currentValues.energyValu)
          setDeemedEnergy(currentValues.deemedEnergy)
          setDeemedTariff(currentValues.deemedTariff)
          setMainTariff(currentValues.mainTariff)
          setFirstDate(currentValues.firstDate)
          setDeemedGener(currentValues.deemedGener) // ADD THIS LINE - Restore deemedGener
        }, 100)
      }
    }
  }

  const updateInvoiceDetails = async () => {
    // Calculate mainAmount and deemedAmount using CURRENT edited values (energyValu, not old energyValue)
    const mainAmount =
      parseFloat(
        energyValu !== null && energyValu !== undefined
          ? energyValu
          : mainEnergy || 0
      ) * parseFloat(mainTariff || 0)

    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)

    // Calculate totalAmount using the newly calculated deemedAmount (not the old deemedGeneration)
    const totalAmount = mainAmount + deemedAmount

    const totaltarif =
      parseFloat(mainTariff || 0) +
      parseFloat(deemedTariff || 0) +
      parseFloat(omAmounts)

    const subTotal =
      state?.data?.proposalType?.type === 'EMI'
        ? totaltarif || 0
        : totalAmount || 0

    // Calculate rounding
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const matchingInvoice = outstandingPayments.find(
      (payment) => payment?.invoiceID === invoiceNumber
    )

    const status = paymentStatus || 'UNPAID'
    // Normalize numeric fields to ensure numbers are sent to backend
    const numericEnergyValue =
      energyValu !== null && energyValu !== undefined
        ? parseFloat(energyValu) || 0
        : parseFloat(mainEnergy || 0) || 0

    const numericDeemedEnergy = parseFloat(deemedEnergy) || 0
    const numericDeemedTariff = parseFloat(deemedTariff) || 0
    const numericMainTariff = parseFloat(mainTariff) || 0
    // Use the newly calculated deemedAmount as deemedGeneration
    const numericDeemedGeneration = deemedAmount

    // Create the updated invoice object
    const updatedInvoice = {
      invoiceNumber: zohoinvoicenumber,
      plantId: state.data.id, // Use state.data.id (not plantId)
      plantName: state.data.plantName,
      entityId: state?.data?.entity?.id || state?.data?.entityId || null,
      energyValue: numericEnergyValue,
      invoiceValue: roundedTotal, // Use rounded total
      roundingOff: roundingOff, // Add rounding off field
      type: state?.data?.proposalType?.type || 'PPA',
      deemedGeneration: numericDeemedGeneration,
      deemedTariff: numericDeemedTariff,
      deemedEnergy: numericDeemedEnergy,
      mainTariff: numericMainTariff,
      remarks: `Manual-generated invoice for ${moment(
        new Date().toISOString()
      ).format('MMMM YYYY')}`,
      // Use invoiceDate instead of sentDate
      invoiceDate: dayjs(firstDate || new Date()).format('YYYY-MM-DD'),
      // Include dueDate in updates
      dueDate: dayjs(
        dueDate ||
        dayjs(firstDate).add(
          Number(state?.data?.paymentTermsDays) || 7,
          'day'
        )
      ).format('YYYY-MM-DD'),
      paymentStatus: status.toUpperCase(),
      zohoinvoicenumber: zohoinvoicenumber,
      autoGenerate: autoGenerate,
      automated: automated,
      updatedAt: new Date().toISOString(),
    }

    const authToken = localStorage.getItem('accessToken')
    // const url = `https://prod.backend.v2.express.de.energy/api/invoices/${invoice_id}`
    const url = `${expressURL}/invoices/${invoice_id}`

    try {
      // Send the PUT request to update the invoice
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify(updatedInvoice),
      })
      if (response.ok) {
        const responseData = await response.json()
        console.log('✅ Invoice updated successfully:', responseData)

        setDateLoed(true)
        setUpdatedAt(new Date().toISOString()) // Update the updatedAt timestamp

        //Sync ALL changes to billing record (including dates, status, and invoice number)
        await syncBillingRecordFromInvoice(
          state.data.id, // Use state.data.id (not plantId)
          firstDate || invoiceDate,
          {
            energyValue: numericEnergyValue,
            deemedEnergy: numericDeemedEnergy,
            mainTariff: numericMainTariff,
            invoiceValue: roundedTotal,
            paymentStatus: status.toUpperCase(),
            invoiceNumber: zohoinvoicenumber,
            invoiceDate: dayjs(firstDate || new Date()).format('YYYY-MM-DD'),
            dueDate: dayjs(
              dueDate ||
              dayjs(firstDate).add(
                Number(state?.data?.paymentTermsDays) || 7,
                'day'
              )
            ).format('YYYY-MM-DD'),
          }
        )

        // Refresh invoice data from database to ensure UI shows latest state
        console.log('🔄 Refreshing invoice data from database...')
        setIsUpdatingFromDB(true)
        try {
          await fetchInvoicesByPlantId(true, false)
        } catch (refreshError) {
          console.error('⚠️ Error refreshing invoice data:', refreshError)
        } finally {
          setIsUpdatingFromDB(false)
        }
      } else {
        console.error('Error updating invoice:', response.statusText)
      }
    } catch (error) {
      console.error('Update Error:', error)
    }
  }

  const createInvoiceDetails = async () => {
    setIsDownloading(true)

    //Check if billing record exists before creating invoice
    if (!billingRecord) {
      setSaveStatus({
        open: true,
        message: billingRecordError || 'No billing record found. Please contact Asset Management.',
        severity: 'error',
      })
      setIsDownloading(false)
      return
    }

    const randomPart = Math.floor(Math.random() * 9000) + 1000 // Generates a 4-digit random number

    const invoicenumber = `INV-${state?.data?.plantName
      ?.split(' ')
      .pop()
      .substring(0, 3)
      .toUpperCase()}-${dayjs(invoiceDate).format('YYYYMM')}`

    // Use edited invoice date (firstDate) instead of the prop invoiceDate
    let individualInvoicedate = `${dayjs(firstDate || invoiceDate).format(
      'YYYY-MM-DD'
    )}`

    const totalBillableUnits = parseFloat(mainEnergy)
    const mainAmount =
      parseFloat(
        energyValu !== null && energyValu !== undefined
          ? energyValu
          : mainEnergy || 0
      ) * parseFloat(mainTariff || 0)
    const deemedAmount =
      parseFloat(deemedEnergy || 0) * parseFloat(deemedTariff || 0)
    // Use the newly calculated deemedAmount, not the old deemedGeneration
    const totalAmount = mainAmount + deemedAmount
    const type = state?.data?.proposalType?.type || 'PPA'

    const totaltarif =
      parseFloat(mainTariff || 0) +
      parseFloat(deemedTariff || 0) +
      parseFloat(omAmounts)

    const subTotal =
      state?.data?.proposalType?.type === 'EMI'
        ? totaltarif || 0
        : totalAmount || 0

    // Calculate rounding
    const roundedTotal = Math.round(subTotal)
    const roundingOff = roundedTotal - subTotal

    const matchingInvoice = outstandingPayments.find(
      (payment) => payment?.invoiceID === invoicenumber
    )
    const status = matchingInvoice?.status || 'UNPAID'

    // Normalize numeric fields to ensure numbers are sent to backend
    const numericTotalBillableUnits = parseFloat(totalBillableUnits) || 0
    const numericDeemedTariff = parseFloat(deemedTariff) || 0
    const numericDeemedEnergy = parseFloat(deemedEnergy) || 0
    const numericMainTariff = parseFloat(mainTariff) || 0

    const newInvoice = {
      invoiceNumber: zohoinvoicenumber,
      plantId: state.data.id, // Use state.data.id (not plantId)
      plantName: state.data.plantName,
      entityId: state?.data?.entity?.id || state?.data?.entityId || null,
      invoiceValue: roundedTotal, // Use rounded total
      roundingOff: roundingOff, // Add rounding off field
      energyValue: numericTotalBillableUnits,
      deemedTariff: numericDeemedTariff,
      deemedEnergy: numericDeemedEnergy,
      mainTariff: numericMainTariff,
      type: type,
      deemedGeneration: deemedAmount,
      paymentStatus: status.toUpperCase(),
      remarks: `Manul-generated invoice for ${moment(
        new Date().toISOString()
      ).format('MMMM YYYY')}`,
      // Always send invoiceDate (replaces previous sentDate usage)
      invoiceDate: individualInvoicedate,
      // Include dueDate in creation
      dueDate: dayjs(
        dueDate ||
        dayjs(individualInvoicedate).add(
          Number(state?.data?.paymentTermsDays) || 7,
          'day'
        )
      ).format('YYYY-MM-DD'),
      zohoUpdates: zohoState,
      zohoinvoicenumber: zohoinvoicenumber,
      organizationId: state.data.organizationId,
      autoGenerate: autoGenerate,
      automated: automated,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }

    console.log('📤 Creating invoice with data:', newInvoice)
    console.log('🔍 plantId being sent:', state.data.id, typeof state.data.id)

    // const url = 'https://prod.backend.v2.express.de.energy/api/invoices' // POST endpoint
    // const url = `https://prod.backend.v2.express.de.energy/api/invoices/${invoice_id}`


    const authToken = localStorage.getItem('accessToken')
    const url = `${expressURL}/invoices`
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify(newInvoice),
      })

      if (response.ok) {
        const createdInvoice = await response.json()
        console.log('✅ Invoice created successfully:', createdInvoice)

        setCreatedAt(new Date().toISOString()) // Set the createdAt timestamp
        setUpdatedAt(new Date().toISOString()) // Set the updatedAt timestamp

        //Sync ALL invoice details to billing record
        await syncBillingRecordFromInvoice(
          state.data.id, // Use state.data.id (not plantId)
          individualInvoicedate,
          {
            energyValue: numericTotalBillableUnits,
            deemedEnergy: numericDeemedEnergy,
            mainTariff: numericMainTariff,
            invoiceValue: roundedTotal,
            paymentStatus: status.toUpperCase(),
            invoiceNumber: zohoinvoicenumber,
            invoiceDate: individualInvoicedate,
            dueDate: dayjs(
              dueDate ||
              dayjs(individualInvoicedate).add(
                Number(state?.data?.paymentTermsDays) || 7,
                'day'
              )
            ).format('YYYY-MM-DD'),
          }
        )
        console.log('✅ Billing record synced with new invoice details')

        return { success: true, data: createdInvoice.data || createdInvoice }
      } else {
        console.error('Error creating invoice:', response.statusText)
      }
      setIsDownloading(false)
    } catch (error) {
      console.error('Create Error:', error)
    }
  }

  const FetchCurrency = (currency) => {
    if (currency === 'INR') return '₹'
    else if (currency === 'USD') return '$'
    return currency
  }

  const handlePrint = async () => {
    setIsDownloading(true)
    try {
      const pdfs = await generatePDF(false, state) // Get array of PDFs

      // Download each PDF with a specific filename
      pdfs.forEach((pdf, index) => {
        const filename = index === 0 ? 'Invoice.pdf' : `O&MInvoice.pdf`
        pdf.save(filename)
      })

      setPrintMode(true)
    } catch (error) {
      setEmailStatus({
        open: true,
        message: 'Error generating PDF',
        severity: 'error',
      })
    }
    setIsDownloading(false)
  }

  const sendEmail = async (recipientEmails, ccEmails, recipientType) => {
    // setIsDownloading(true)
    const buttonType = recipientType === 'team' ? 'emailTeam' : 'emailCustomer'
    setProcessingButton(buttonType)
    try {
      //receipeits resolved in backend
      const invoice_id = invoiceDetails?.[0]?._id
      if (!invoice_id) {
        throw new Error('No invoice selected. Please create or select an invoice.')
      }

      // Get PDFs
      const pdfs = await generatePDF(true, state)

      //only emailing first pdf
      const pdf = pdfs[0];
      const pdfBlob = pdf.output('blob');

      const formData = new FormData();
      formData.append('pdf', pdfBlob, 'Invoice.pdf');
      formData.append('invoiceId', invoice_id);
      formData.append('recipientType', recipientType);

      const token = localStorage.getItem('accessToken');

      //console.log(`Sending ${recipientType} email for invoiceId=${invoice_id}`);

      // Send to backend
      const response = await axios.post(
        `${expressURL}/invoice-reminder/send-email`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      // Check if email was sent successfully
      if (response.status === 201 || response.status === 200) {
        setEmailStatus({
          open: true,
          message: `Email sent successfully to ${recipientType}`,
          severity: 'success',
        })

        // If customer email, update invoice with email status
        if (recipientType === 'customer') {
          try {
            const invoice_id = invoiceDetails?.[0]?._id
            if (invoice_id) {
              const currentDate = dayjs().format('YYYY-MM-DD')

              // Update invoice with emailSent: true and sentDate
              await updateInvoiceEmailStatus(invoice_id, true, currentDate)

              console.log('Invoice email status updated successfully')

              // Immediately update local state to reflect the change in UI
              setInvoiceDetails((prevDetails) => {
                if (prevDetails && prevDetails.length > 0) {
                  const updatedDetails = [...prevDetails]
                  updatedDetails[0] = {
                    ...updatedDetails[0],
                    emailSent: true,
                    sentDate: currentDate,
                  }
                  return updatedDetails
                }
                return prevDetails
              })
            }
          } catch (e) {
            console.error('Failed to update invoice email status:', e)
          }
        }
      } else {
        throw new Error('Failed to send emails')
      }
    } catch (error) {
      console.error('Email sending error:', error)
      setEmailStatus({
        open: true,
        message: `Failed to send email to ${recipientType}: ${error.message}`,
        severity: 'error',
      })
      // Update invoice with failure status for customer email
      if (recipientType === 'customer') {
        try {
          const invoice_id = invoiceDetails?.[0]?._id
          if (invoice_id) {
            const currentDate = dayjs().format('YYYY-MM-DD')

            // Update invoice with emailSent: false and sentDate
            await updateInvoiceEmailStatus(invoice_id, false, currentDate)

            // Immediately update local state to reflect the failure in UI
            setInvoiceDetails((prevDetails) => {
              if (prevDetails && prevDetails.length > 0) {
                const updatedDetails = [...prevDetails]
                updatedDetails[0] = {
                  ...updatedDetails[0],
                  emailSent: false,
                  sentDate: currentDate,
                }
                return updatedDetails
              }
              return prevDetails
            })
          }
        } catch (e) {
          console.error('Failed to update invoice email status (failure):', e)
        }
      }
    } finally {
      // setIsDownloading(false)
      setProcessingButton(null) // Reset processing state

      setConfirmDialogOpen(false)
    }
  }

  // Handle confirm email with dynamic recipient loading
  const handleConfirmEmail = async () => {
    try {
      const { toEmails, ccEmails } = emailDialogData
      await sendEmail(toEmails, ccEmails, emailType)
    } catch (error) {
      console.error('Email confirmation error:', error)
      setEmailStatus({
        open: true,
        message: `Error sending email: ${error.message}`,
        severity: 'error',
      })
    }
  }

  const handleEditClick = () => {
    setSnackbarOpen(true)
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSnackbarOpen(false)
  }

  const handleFaultEventChange = (event, key) => {
    const value = parseFloat(event.target.value || 0)
    setFaultEvents((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const handleAccountableFailureChange = (event) => {
    const value = parseFloat(event.target.value || 0)
    setAccountableFailure(value)
  }

  const handleEditPayment = (id) => {
    setEditingPaymentId(id)
  }

  const handleSavePayment = (invoiceID, invoice_id) => {
    const matchingInvoice = outstandingPayments.find(
      (payment) => payment.invoiceID === invoiceID
    )
    const paymentStatus = matchingInvoice?.status

    updateMultipleFields({ invoiceID, invoice_id, paymentStatus })

    setEditingPaymentId(null)
  }

  const handleCancelPayment = (id) => {
    setEditingPaymentId(null)
  }

  const handlePaymentChange = (id, field, value) => {
    setOutstandingPayments((prevPayments) => {
      return prevPayments.map((payment) => {
        if (payment.id === id) {
          const updatedPayment = { ...payment, [field]: value }
          if (field === 'status') {
            updatedPayment.pendingAmount =
              value === 'PAID' ? 0 : updatedPayment.invoiceAmount
          }
          if (field === 'invoiceAmount') {
            updatedPayment.pendingAmount =
              payment.status === 'PAID' ? 0 : Number(value)
          }
          return updatedPayment
        }
        return payment
      })
    })
  }

  useEffect(() => {
    if (energyValue !== null) {
      setEnergyValu(parseFloat(energyValue).toFixed(2))
      const newTotals = calculateTotals()
    }
  }, [energyValue, firstDate, setDeemedEnergy, setDeemedTariff])

  useEffect(() => {
    if (deemedGeneration !== null) {
      setDeemedGener(parseFloat(deemedGeneration).toFixed(2))
      const newTotals = calculateTotals()
    }
  }, [deemedGeneration])

  const handleAddPayment = () => {
    const newId = `payment-${outstandingPayments.length}`
    const newPayment = {
      id: newId,
      date: dayjs().format('YYYY-MM'),
      transactionNo: `INV-${dayjs().format('YYYY/MM')}-${String(
        outstandingPayments.length + 1
      ).padStart(3, '0')}`,
      type: 'INVOICE',
      status: 'UNPAID',
      invoiceAmount: 0,
      pendingAmount: 0,
    }
    setOutstandingPayments([...outstandingPayments, newPayment])
    setEditingPaymentId(newId)
  }

  const handleDeletePayment = (id) => {
    setOutstandingPayments((prevPayments) =>
      prevPayments.filter((payment) => payment.id !== id)
    )
  }

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      @media print {
        .print-no-border {
          border: none !important;
        }
        .print-no-border td, .print-no-border th {
          border: none !important;
        }
        .no-print {
          display: none !important;
           border: none !important;
        }
        input {
          border: none !important;
          background: transparent !important;
        }
        /* Hide MUI TextField borders in PDF */
        .MuiInput-root:before,
        .MuiInput-root:after {
          border-bottom: none !important;
        }
        .MuiInputBase-root {
          border: none !important;
        }
        .MuiInputBase-input {
          border: none !important;
          -webkit-appearance: none !important;
        }
        /* Hide all TextField underlines */
        .MuiInput-underline:before,
        .MuiInput-underline:after,
        .MuiInput-underline:hover:not(.Mui-disabled):before {
          border-bottom: none !important;
        }
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  useEffect(() => {
    if (invoiceReportList && state) {
      const totalEnergyGenerated = parseFloat(
        invoiceReportList.totalEnergyGenerated || 0
      )
      const logTotal = parseFloat(invoiceReportList.logTotal || 0)
      const totalMultiplyingFactor = invoiceReportList.totalMultiplyingFactor

      const tariff =
        state?.data?.proposalType?.type !== 'EMI'
          ? parseFloat(state?.data?.proposalType?.tariff || 0)
          : parseFloat(state?.data?.proposalType?.monthlyEmiAmount || 0)

      const omAmount = parseFloat(
        state.data?.proposalType?.monthlyOMAmount || 0
      )

      // Get fault values and their corresponding multiplying factors
      const faultData = invoiceReportList.logTotalFault || {}
      const faultMultipliers =
        invoiceReportList.logTotalFaultMultiplyingFactor || {}

      const initialFaults = {
        GridFailure: parseFloat(faultData.GridFailure || 0),
        InverterFailure: parseFloat(faultData.InverterFailure || 0),
        Manuallyinverterbreakerturnedoff: parseFloat(
          faultData.Manuallyinverterbreakerturnedoff || 0
        ),
        VoltageFluctuations: parseFloat(faultData.VoltageFluctuations || 0),
        RelayFailureMCCBFailure: parseFloat(
          faultData.RelayFailureMCCBFailure || 0
        ),
        AnyOtherFault: parseFloat(faultData.AnyOtherFault || 0),
        CableTerminationIssue: parseFloat(faultData.CableTerminationIssue || 0),
        AnyEquipmentFailure: parseFloat(faultData.AnyEquipmentFailure || 0),
      }

      setFaultEvents(initialFaults)

      // Calculate total fault with multiplying factors
      const totalFault = Object.keys(initialFaults).reduce((sum, faultType) => {
        const faultValue = parseFloat(initialFaults[faultType]) || 0
        const multiplier = parseFloat(faultMultipliers[faultType]) || 1
        const calculatedFault = faultValue * multiplier
        return sum + calculatedFault
      }, 0)

      setAccountableFailure(totalFault)
      setOmAmounts(omAmount)

      // Only set calculated values if no invoice AND no billing record data exists
      if ((!invoiceDetails || invoiceDetails.length === 0) && !billingRecord) {
        // Format energy values - show '0' for zero, no decimals for whole numbers, 2 decimals otherwise
        const formattedEnergy =
          totalEnergyGenerated === 0
            ? '0'
            : totalEnergyGenerated % 1 === 0
              ? totalEnergyGenerated.toString()
              : parseFloat(totalEnergyGenerated).toFixed(2)

        console.log('📊 Setting energy values from invoiceReportList (no billing record):', {
          formattedEnergy, totalFault, tariff
        })
        setMainEnergy(formattedEnergy)
        setDeemedEnergy(totalFault)
        setMainTariff(tariff)
        setEnergyValu(formattedEnergy)
      } else if (billingRecord) {
        console.log('✅ Skipping invoiceReportList values - using billing record data')
      }

      setIsLoading(false)
    }
  }, [invoiceReportList, state, invoiceDetails, billingRecord]) // Added billingRecord as dependency

  useEffect(() => {
    const style = document.createElement('style')
    style.innerHTML = `
      @media print {
        .print-no-border {
          border: none !important;
        }
        .print-no-border td, .print-no-border th {
          border: none !important;
        }
        input {
          border: none !important;
          background: transparent !important;
        }
        /* Hide MUI TextField borders in PDF */
        .MuiInput-root:before,
        .MuiInput-root:after {
          border-bottom: none !important;
        }
        .MuiInputBase-root {
          border: none !important;
        }
        .MuiInputBase-input {
          border: none !important;
          -webkit-appearance: none !important;
        }
        /* Hide all TextField underlines */
        .MuiInput-underline:before,
        .MuiInput-underline:after,
        .MuiInput-underline:hover:not(.Mui-disabled):before {
          border-bottom: none !important;
        }
      }
    `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  useEffect(() => {
    const allInvoice = async () => {
      const authToken = localStorage.getItem('accessToken')
      const url = `${expressURL}/invoices`

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            ...(authToken && { Authorization: `Bearer ${authToken}` }),
          },
        })

        if (!response.ok) {
          throw new Error(`HTTP Error! status: ${response.status}`)
        }

        const responseData = await response.json()
        const data = { data: responseData.invoices || [] }
        const currentTotals = calculateTotals() // Get current totals

        const formattedPayments = processInvoiceData(
          data.data,
          state.data.id, // Use state.data.id (not plantId)
          invoiceDetails,
          currentTotals,
          energyValu,
          mainEnergy
        )

        setOutstandingPayments(formattedPayments)
      } catch (error) {
        console.error(error)
      }
    }

    allInvoice()
  }, [
    invoiceDate,
    mainEnergy,
    mainTariff,
    deemedEnergy,
    deemedTariff,
    energyValu,
  ]) // Added energyValu to dependencies

  useEffect(() => {
    const summary = []
    Object.entries(faultEvents).forEach(([key, value]) => {
      if (value > 0) {
        summary.push({
          faultType: key.replace(/([A-Z])/g, ' $1').trim(),
          duration: '0:00',
          unitLoss: value,
        })
      }
    })
    setFaultSummary(summary)
  }, [faultEvents])

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </div>
    )
  }

  const totals = calculateTotals()

  // Handle energy value changes
  const handleEnergyValueChange = (newValue) => {
    setEnergyValu(newValue)
    setMainEnergy(newValue)
    setEnergyValu(newValue)
  }

  const handleDateValueChange = (newValue) => {
    const normalized = dayjs(newValue).format('YYYY-MM-DD')
    console.log('📅 Invoice date changed to:', normalized)
    console.log('🗓️ Selected billing month:', invoiceDate)
    setFirstDate(normalized)
    // Update default due date when invoice date changes
    const terms = Number(state?.data?.paymentTermsDays) || 7
    const nextDue = dayjs(normalized).add(terms, 'day').format('YYYY-MM-DD')
    setDueDate(nextDue)
  }

  const handleDueDateChange = (newValue) => {
    setDueDate(newValue)
  }

  // ADD THIS FUNCTION - Handle deemed generation changes
  const handleDeemedGenerationChange = (newValue) => {
    setDeemedGener(newValue)
  }

  // ADD THIS FUNCTION - Handle save operation
  const handleSave = async () => {
    setProcessingButton('save') // Set processing state
    try {
      console.log('💾 Saving invoice...')

      setSaveStatus({
        open: true,
        message: 'Saving invoice...',
        severity: 'info',
      })

      // Validate billing record exists
      if (!billingRecord) {
        throw new Error('No billing record found. Cannot create invoice.')
      }

      setIsSaving(true)
      setIsUpdatingFromDB(true)

      // Determine if this is an update or create based on current invoiceDetails state
      const existingInvoiceId = invoiceDetails?.find((item) => item._id)?._id
      let result
      let isUpdate = false

      if (existingInvoiceId) {
        // Invoice exists - update it
        console.log('📝 Updating existing invoice:', existingInvoiceId)
        isUpdate = true
        await updateInvoiceDetails()
        result = { success: true }
      } else {
        // No invoice in state - call create (backend will upsert if needed)
        console.log('✨ Creating new invoice...')
        result = await createInvoiceDetails()

        // If invoice was created/updated successfully, update invoiceDetails immediately
        if (result?.success && result?.data) {
          const newInvoiceData = result.data
          // Check if backend did an update instead of create
          if (result.isUpdate) {
            console.log('📝 Backend performed update instead of create')
            isUpdate = true
          }
          setInvoiceDetails([{
            _id: newInvoiceData.id || newInvoiceData._id,
            invoiceNumber: newInvoiceData.invoiceNumber || zohoinvoicenumber,
            plantId: newInvoiceData.plantId || state.data.id,
            plantName: newInvoiceData.plantName || state.data.plantName,
            invoiceValue: newInvoiceData.invoiceValue,
            energyValue: newInvoiceData.energyValue,
            deemedTariff: newInvoiceData.deemedTariff,
            deemedEnergy: newInvoiceData.deemedEnergy,
            mainTariff: newInvoiceData.mainTariff,
            type: newInvoiceData.type,
            deemedGeneration: newInvoiceData.deemedGeneration,
            paymentStatus: newInvoiceData.paymentStatus,
            invoiceDate: newInvoiceData.invoiceDate,
            dueDate: newInvoiceData.dueDate,
            sentDate: newInvoiceData.sentDate, // Include sentDate
            emailSent: newInvoiceData.emailSent, // Include emailSent
            zohoinvoicenumber: newInvoiceData.zohoinvoicenumber || zohoinvoicenumber,
          }])
        }
      }

      // Mark as not updating before showing modal
      setIsUpdatingFromDB(false)
      setIsSaving(false)
      setProcessingButton(null)

      // Show appropriate success message
      const successMessage = isUpdate
        ? `Invoice ${zohoinvoicenumber} has been updated successfully.`
        : `Invoice ${zohoinvoicenumber} has been created with status UNPAID.`

      setSaveStatus({
        open: true,
        message: isUpdate ? 'Invoice updated successfully!' : 'Invoice created successfully!',
        severity: 'success',
      })

      setInvoiceModal({
        open: true,
        type: 'success',
        title: isUpdate ? 'Invoice Updated' : 'Invoice Created',
        message: successMessage,
      })

    } catch (error) {
      console.error('❌ Error saving invoice:', error)
      setSaveStatus({
        open: true,
        message: `Error saving invoice: ${error.message}`,
        severity: 'error',
      })
      // Reset state on error
      setProcessingButton(null)
      setIsSaving(false)
      setIsUpdatingFromDB(false)
    }
  }

  // ADD THIS FUNCTION - Handle download operation
  const handleDownload = async () => {
    setProcessingButton('download') // Set processing state
    try {
      setSaveStatus({
        open: true,
        message: 'Generating PDF...',
        severity: 'info',
      })

      // Store current values for PDF generation
      const preservedValues = {
        energyValu,
        deemedEnergy,
        deemedTariff,
        mainTariff,
        firstDate,
        deemedGener,
      }

      // Generate PDF with current values
      await generatePDFWithValues(preservedValues)

      setSaveStatus({
        open: true,
        message: 'Download completed successfully!',
        severity: 'success',
      })
    } catch (error) {
      console.error('Error downloading invoice:', error)
      setSaveStatus({
        open: true,
        message: 'Error generating PDF',
        severity: 'error',
      })
    } finally {
      setProcessingButton(null)
    }
  }

  // Helper function to check if invoice can be viewed based on billing record status
  // Note: Main control is in PlantBusinessView.handleInvoiceopen() - this is a safeguard
  const canViewInvoice = () => {
    if (!billingRecord) {
      return false // Cannot view invoice if no billing record exists
    }

    const status = billingRecord.paymentStatus
    // Allow viewing if status is NOT 'To Be Verified'
    return status !== 'To Be Verified'
  }

  const handleExportToZoho = () => {
    setExportZohoDialogOpen(true)
  }

  const handleConfirmExportToZoho = async () => {
    // setIsDownloading(true)
    setProcessingButton('exportZoho')
    setExportZohoDialogOpen(false)

    try {
      // Fetch latest invoice data
      await fetchInvoicesByPlantId()

      const exportResult = await exportToZoho({
        invoiceDetails,
        state,
        invoiceDate,
        totals: calculateTotals(),
        energyValu,
        mainEnergy,
        mainTariff,
        deemedEnergy,
        deemedTariff,
        omAmounts,
        zohoState,
        zohoinvoicenumber,
      })

      if (exportResult.success) {
        setEmailStatus({
          open: true,
          message: exportResult.message,
          severity: 'success',
        })
        // IMPORTANT: Refresh invoice data to get the updated invoice number from MongoDB
        await fetchInvoicesByPlantId()

        // Also refresh the Zoho invoice number to show the stored one
        await fetchZohoInvoicesByPlantId()

        // Update the zohoConnected status
        setZohoConnected(true)
      } else {
        setEmailStatus({
          open: true,
          message: exportResult.message,
          severity: 'error',
        })
      }
    } catch (error) {
      setEmailStatus({
        open: true,
        message: `Unexpected error: ${error.message}`,
        severity: 'error',
      })
    } finally {
      // setIsDownloading(false)
      setProcessingButton(null) // Reset processing state
    }
  }

  const invoiceTableProps = {
    energyValu,
    setEnergyValu: handleEnergyValueChange,
    mainEnergy,
    setMainEnergy: handleEnergyValueChange,
    totals: calculateTotals(),
    setMainTariff,
    mainTariff,
    state,
    invoiceDate,
    handleEditClick,
    energyValue,
    deemedEnergy,
    setDeemedEnergy,
    deemedTariff,
    setDeemedTariff,
    deemedGeneration,
    deemedGener, // ADD THIS LINE - Pass deemedGener to InvoiceTable
    setDeemedGener: handleDeemedGenerationChange, // ADD THIS LINE - Pass the handler
    omAmounts,
    setOmAmounts,
    months,
    firstDate,
    setFirstDate: handleDateValueChange,
    dueDate,
    setDueDate: handleDueDateChange,
    invoiceDetails,
    zohoState,
    zohoinvoicenumber,
    billingRecord,
    organizationData, // Organization details from V4 API
    plantSize, // Plant size from billing record
  }

  return (
    <div
      className={`no-print ${classes.root}`}
      style={{ marginBottom: '20px' }}
    >
      {billingRecordError && (
        <MuiAlert
          severity="error"
          style={{ marginBottom: '20px' }}
          onClose={() => setBillingRecordError(null)}
        >
          {billingRecordError}
        </MuiAlert>
      )}

      <ActionButtons
        onEmailTeam={() => handleEmailButtonClick('team')}
        onEmailCustomer={() => handleEmailButtonClick('customer')}
        onSave={handleSave}
        onDownload={handleDownload}
        onExportToZoho={handleExportToZoho}
        // isDownloading={isDownloading}
        processingButton={processingButton} // Pass the processing state
        zohoConnected={zohoConnected}
        paymentStatus={paymentStatus}
        dbPaymentStatus={dbPaymentStatus} // Pass the saved DB status
        onPaymentStatusChange={handlePaymentStatusChange}
        invoiceExists={invoiceDetails && invoiceDetails.length > 0} // Pass invoice existence check
        sentDate={
          invoiceDetails && invoiceDetails.length > 0
            ? invoiceDetails[0].sentDate
            : null
        } // Pass sent date
        emailSent={
          invoiceDetails && invoiceDetails.length > 0
            ? invoiceDetails[0].emailSent
            : false
        } // Pass email sent status
        autoGenerate={autoGenerate}
        onAutoGenerateChange={handleAutoReminderClick}
      />

      {/* Show alert if billing record status is "To Be Verified" - This shouldn't happen as dialog won't open, but kept as safeguard */}
      {billingRecord && billingRecord.paymentStatus === 'To Be Verified' && (
        <MuiAlert
          severity="warning"
          style={{ marginBottom: '20px' }}
        >
          ⚠️ Billing record status is "To Be Verified". Invoice operations are restricted. Please contact Asset Management.
        </MuiAlert>
      )}

      <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <div>
          <InvoiceTable {...invoiceTableProps} />

          {/* <div className={classes.containerStyle} id="annexurePage">
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <img
                  style={{ height: 70, width: 150 }}
                  src={LogoP1}
                  alt="DE logo1"
                />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
                      {zohoState?.organizationName || 'DE Solar Assets Series 2 LLP'}
                    </div>
                  </div>
              </div>

              <div className={classes.containerStyle}>
                <div className={classes.Boldstyle}>Annexure 1 : Fault Events</div>
                <div style={{ marginTop: '20px' }}>
                  Summary of Fault Events for the month {months[CurrentMonth]}{' '}
                  {dayjs(invoiceDate).format('YYYY')}
                  <FaultEventsTable
                    classes={classes}
                    faultEvents={faultEvents}
                    handleFaultEventChange={handleFaultEventChange}
                    totals={totals}
                    accountableFailure={accountableFailure}
                    handleAccountableFailureChange={
                      handleAccountableFailureChange
                    }
                  />
                  <div style={{ marginTop: '20px' }}>
                    <FaultSummaryTable
                      classes={classes}
                      faultSummary={faultSummary}
                      invoiceDate={invoiceDate}
                    />
                  </div>
                </div>

                <OutstandingPaymentsTable
                  classes={classes}
                  outstandingPayments={outstandingPayments}
                  editingPaymentId={editingPaymentId}
                  handlePaymentChange={handlePaymentChange}
                  handleEditPayment={handleEditPayment}
                  handleSavePayment={handleSavePayment}
                  handleCancelPayment={handleCancelPayment}
                  handleDeletePayment={handleDeletePayment}
                  handleAddPayment={handleAddPayment}
                  printMode={printMode}
                  totals={totals}
                  state={state}
                  FetchCurrency={FetchCurrency}
                />
              </div>
            </div> */}
        </div>
      </div>
      <EmailDialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        emailType={emailType}
        onConfirm={handleConfirmEmail}
        toEmails={emailDialogData?.toEmails}
        ccEmails={emailDialogData?.ccEmails}
        isLoading={emailDialogData?.isLoading}
        error={emailDialogData?.error}
        isSending={
          (processingButton === 'emailTeam' && emailType === 'team') ||
          (processingButton === 'emailCustomer' && emailType === 'customer')
        }
      />

      <AutoReminderDialog
        open={autoReminderDialogOpen}
        onClose={() => setAutoReminderDialogOpen(false)}
        onConfirm={handleConfirmAutoReminder}
        currentStatus={autoGenerate}
      />

      <PaymentStatusDialog
        open={paymentStatusDialogOpen}
        onClose={() => setPaymentStatusDialogOpen(false)}
        onConfirm={handleConfirmPaymentStatusChange}
        newStatus={pendingPaymentStatus}
        currentStatus={dbPaymentStatus}
      />

      <ExportZohoDialog
        open={exportZohoDialogOpen}
        onClose={() => setExportZohoDialogOpen(false)}
        onConfirm={handleConfirmExportToZoho}
        plantName={state?.data?.plantName}
        invoiceNumber={invoiceNumber || zohoinvoicenumber}
      />

      <Snackbar
        open={emailStatus.open}
        autoHideDuration={6000}
        onClose={() => setEmailStatus((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          severity={emailStatus.severity}
          sx={{ width: '100%' }}
          onClose={() => setEmailStatus((prev) => ({ ...prev, open: false }))}
        >
          {emailStatus.message}
        </Alert>
      </Snackbar>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          sx={{ width: '100%' }}
        >
          Please edit in plant details dashboard.
        </Alert>
      </Snackbar>

      <Snackbar
        open={saveStatus.open}
        autoHideDuration={6000}
        onClose={() => setSaveStatus({ ...saveStatus, open: false })}
      >
        <Alert severity={saveStatus.severity} sx={{ width: '100%' }}>
          {saveStatus.message}
        </Alert>
      </Snackbar>



      {/* Invoice Modal Popup - Center of Page */}
      {invoiceModal.open && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1500,
            animation: 'fadeIn 0.3s ease-in-out',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '32px',
              maxWidth: '420px',
              width: '90%',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              animation: 'slideUp 0.3s ease-in-out',
            }}
          >
            {/* Header with close button */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginBottom: '16px',
              }}
            >
              <div style={{ flex: 1 }}>
                {/* Icon and Title */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: invoiceModal.type === 'success' ? '#e8f5e9' : '#fff3e0',
                      color: invoiceModal.type === 'success' ? '#4caf50' : '#ff9800',
                      fontSize: '24px',
                      fontWeight: 'bold',
                    }}
                  >
                    {invoiceModal.type === 'success' ? '✓' : '!'}
                  </div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#333',
                    }}
                  >
                    {invoiceModal.title}
                  </h3>
                </div>
              </div>
              {/* Close Button */}
              <button
                onClick={() => setInvoiceModal({ ...invoiceModal, open: false })}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '28px',
                  cursor: 'pointer',
                  color: '#999',
                  padding: '0',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
                title="Close modal"
              >
                ×
              </button>
            </div>

            {/* Message */}
            <p
              style={{
                fontSize: '14px',
                color: '#666',
                lineHeight: '1.6',
                margin: '0 0 24px 0',
              }}
            >
              {invoiceModal.message}
            </p>

            {/* Action Button */}
            <button
              onClick={() => setInvoiceModal({ ...invoiceModal, open: false })}
              style={{
                width: '100%',
                padding: '10px 16px',
                backgroundColor: invoiceModal.type === 'success' ? '#4caf50' : '#ff9800',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = invoiceModal.type === 'success' ? '#45a049' : '#e68900'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = invoiceModal.type === 'success' ? '#4caf50' : '#ff9800'
              }}
            >
              Close
            </button>
          </div>

          <style>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
            @keyframes slideUp {
              from {
                transform: translateY(20px);
                opacity: 0;
              }
              to {
                transform: translateY(0);
                opacity: 1;
              }
            }
          `}</style>
        </div>
      )}
    </div>
  )
}

export default InvoiceBill
